import React from 'react';
import { X } from 'lucide-react';

function ApplicationTags({
    tags = []
}) {
    return (
        <div className="flex flex-col gap-3">
            <div className="flex gap-2 flex-wrap">
                {tags.map((tag, index) => (
                    <div
                        key={index}
                        className="bg-card/30 text-white px-3 py-1 rounded-full flex items-center gap-1 text-sm"
                    >
                        {tag}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ApplicationTags;

